import { useLanguage } from "@/lib/LanguageContext";
import { Clock, Award, Users, ShieldCheck } from "lucide-react";

export const About = () => {
  const { t } = useLanguage();

  return (
    <section id="about" data-testid="about-section" className="py-20 md:py-32 relative" style={{ background: '#0c2d48' }}>
      <div className="absolute inset-0 noise-overlay" />
      <div className="relative z-10 container mx-auto px-4 md:px-8 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          {/* Left content */}
          <div className="lg:col-span-7">
            <span className="text-teal text-xs tracking-[0.4em] uppercase font-body font-semibold mb-4 block">
              SousA Auto Service Inc
            </span>
            <h2 className="font-heading text-3xl md:text-5xl tracking-wide uppercase font-bold text-white mb-8">
              {t.about.title}
            </h2>
            <div className="w-20 h-[3px] bg-gold mb-10" />

            <div className="space-y-5 font-body text-base text-slate-300 leading-relaxed">
              <p>{t.about.p1}</p>
              <p>{t.about.p2}</p>
              <p>{t.about.p3}</p>
            </div>

            {/* Feature icons */}
            <div className="grid grid-cols-2 gap-6 mt-12">
              {[
                { icon: Award, label: "Certified Technicians" },
                { icon: Users, label: "3 Languages" },
                { icon: ShieldCheck, label: "Parts Warranty" },
                { icon: Clock, label: "Same Day Service" },
              ].map((feat, i) => (
                <div key={i} className="flex items-center gap-3 group">
                  <div className="w-10 h-10 flex items-center justify-center border border-gold/20 group-hover:border-gold/50 transition-all">
                    <feat.icon className="w-5 h-5 text-gold" strokeWidth={1.5} />
                  </div>
                  <span className="font-body text-sm text-slate-300 group-hover:text-white transition-colors">{feat.label}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Right - Hours + Image */}
          <div className="lg:col-span-5 space-y-8">
            {/* Image */}
            <div className="relative overflow-hidden aspect-[4/3]">
              <img
                src="https://images.pexels.com/photos/3807811/pexels-photo-3807811.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
                alt="Mechanic working"
                className="w-full h-full object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-navy-dark/80 to-transparent" />
            </div>

            {/* Business Hours */}
            <div className="bg-navy-paper border border-white/5 p-8" data-testid="business-hours">
              <h3 className="font-heading text-xl tracking-wider uppercase text-white mb-6">
                {t.about.hours}
              </h3>
              <div className="space-y-4 font-body">
                <div className="flex justify-between items-center text-sm">
                  <span className="text-slate-400">{t.about.monFri}</span>
                  <span className="text-teal font-semibold">{t.about.monFriTime}</span>
                </div>
                <div className="w-full h-px bg-white/5" />
                <div className="flex justify-between items-center text-sm">
                  <span className="text-slate-400">{t.about.sat}</span>
                  <span className="text-teal font-semibold">{t.about.satTime}</span>
                </div>
                <div className="w-full h-px bg-white/5" />
                <div className="flex justify-between items-center text-sm">
                  <span className="text-slate-400">{t.about.sun}</span>
                  <span className="text-red-400 font-semibold">{t.about.sunTime}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
